import { Component, ViewEncapsulation, OnInit, ChangeDetectorRef, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
declare var jQuery: any;
import * as _ from 'lodash';
import * as moment from 'moment';
//import * as moment-timezone from 'moment-timezone'

// import { ISlimScrollOptions } from 'ng2-slimscroll';
import { PrimecalendarService } from './../primecalendar.service';
import {
    MessageEvent, SignInEvent, DatePickerToCalendarEvent, OpenFrameEvent, SidemenuToCalendarEvent,
    LoaderEvent, SidemenuSubCategory, HiddenFooter, SetAllMemberCheck
} from './../../shared/message.event';
import { AppService } from '../../app.service';
import { CONSTANT_VALUES } from '../../constants/constant-values';
import { CONSTANT_MESSAGES } from '../../constants/constants-messages';
import { UtilityFunctions } from '../../shared/utility-functions';

@Component({
    selector: 'app-prime-calendar',
    templateUrl: 'prime-calendar.component.html',
    styleUrls: ['prime-calendar.component.css'],
    encapsulation: ViewEncapsulation.None,
    providers: [PrimecalendarService, MessageEvent, SignInEvent,
        DatePickerToCalendarEvent, AppService, OpenFrameEvent, SidemenuToCalendarEvent, LoaderEvent, SidemenuSubCategory, HiddenFooter, SetAllMemberCheck]

})

export class PrimeCalendarComponent implements OnInit, OnDestroy {
    private _router;
    // start prime calendar (full calendar)
    events: any[];
    header: any;
    event: MyEvent;
    dialogVisible: boolean = false;
    idGen: number = 100;
    headerConfig: any;
    // End prime calendar (full calendar)

    private paymentFilterArray = ['All', 'Confirmed'];
    private paymentfilter = 'All';
    private currentFilterValue = 'All';
    private popupTitle;
    private eventData = {
        start: '',
        end: '',
        startTimeNew: moment(),
        endTimeNew: moment()
    };
    private selectedUnit = '';
    private shouldSlide: boolean = false;
    private facility_list;
    private showFacilities = false;
    private category = {};
    // private scrollOptions: ISlimScrollOptions;
    private bookingData = [];
    private facility = {
        'name': '',
        'noOfUnits': '',
        'slotDuration': '',
        'category': '',
        'timings': {
            'openTime': '',
            'closeTime': ''
        },
        'unitNames': [],
        'icon': '',
        'isChargable': false,
        'amount': {
            'currency': 'USD',
            'value': ''
        },
        'isHoldBooking': false,
        'holdBookingDays': '',
        'isAttendeeCountRequired': false,
        'reminder': {
            'unit': 'days',
            'value': ''
        },
        'maxWeekdayBooking': '',
        'maxWeekendBooking': '',
        'isWaitlistEnabled': false,
        'waitlistCount': '',
        'vendorId': '',
        'isActive': true,
        'peekStartTime': '',
        'peekEndTime': '',
        'maxBookingHoursWeekday': '',
        'maxBookingHoursWeekend': '',
        'maxNumberOfPeopleWeekday': '',
        'maxNumberOfPeopleWeekend': '',
        'notificationAcceptanceHour': '',
        'peakUnitsCount': '',
        'createdBy': '',
        'breakTimings': [],
        'peekTimings': [],
        'isMaxBookingPerMembership': false,
        'isMaxBookingPerPerson': false,
        'isPeakTimeEnabled': true,
        'isBreakTimeEnabled': true,
        'maxBookingHoursMonth': ''
    };
    private schedulerDate;
    private calendarDate: any;
    private vendor;
    private windowHeight = window.innerHeight;
    private topNav = 56;
    private midNav = 45;
    private footer = 35;
    private container = 20;
    private divHeight = 30;
    private listheight = 11;
    private height: any;
    private startTimeOfFacility: string = '00:00:00';
    private endTimeOfFacility: string = '24:00:00';
    private popUpMessage = 'Are you sure, you want to mark this booking as payment received?';
    private popUpBookingUnavailableMessage = 'Sorry. The bookings are not open for this slot.';
    private bookingPopupMessage = '';
    private currentEvent: any;
    private facilityRule = {
        'timings': {
            'openTime': '',
            'closeTime': ''
        },
        'peekTimings': [],
        'breakTimings': []
    };
    private peakTimeList = []
    private currentBookingList = [];
    private calendarData;
    private delegate: boolean = false;
    calenderLocale: any = {};
    scheduleLocale: any = {};
    private clubName = '';
    private message = '';
    private filterSate = 'All';
    private selectAll = false;
    private selectConfirmed = false;
    private facilityData = [];
    private unitNameList = [];
    private currency = CONSTANT_VALUES.currency;
    private firstDay;
    private lastDay;
    private bookingSlotStart;
    private bookingSlotEnd;
    private timezoneOffset;
    private utilityFunctions = new UtilityFunctions();
    constructor(private router: Router, private calendarService: PrimecalendarService, private messageEvent: MessageEvent,
        private signInEvent: SignInEvent, private datePickerToCalendarEvent: DatePickerToCalendarEvent, private appService: AppService,
        private openFrameEvent: OpenFrameEvent, private sidemenuToCalendarEvent: SidemenuToCalendarEvent,
        private hiddenFooter: HiddenFooter, private loaderEvent: LoaderEvent, private cd: ChangeDetectorRef,
        private sidemenuSubCategory: SidemenuSubCategory, private setAllMemberCheck: SetAllMemberCheck) {
        this._router = router;

        this.vendor = JSON.parse(atob(localStorage.getItem('vendor')));
        // We do not specify class name here, if it is a staff role
        if (this.vendor.role == CONSTANT_VALUES.SUPER_ADMIN) {
            if (this.vendor.subVendors.length > 0) {
                let subVendor = this.vendor.subVendors[0];
                this.clubName = subVendor.clubName;
            }
        } else {
            this.clubName = this.vendor.clubName;
        }
        this.emitTypeBroadcast();
        //    this.scrollOptions = {
        //        barBackground: "#343a40", barOpacity: "0.6", position: "right",
        //        barWidth: "6", barBorderRadius: "5",barMargin:"1px 1px",gridBackground:"#adb5bd",gridOpacity:"1",gridWidth:"4",gridBorderRadius:"10",gridMargin:"1px 2px"
        //     };
        this.registerTypeBroadcast();
        // if (this._appService.getVendorRole() === CONSTANT_VALUES.ROLE_STAFF) {
        //      this._appService.getFacilityByClub(this.vendor.vendorId);
        //     if (localStorage.getItem('vendor_facilityData')) {
        //         this.facilityData = JSON.parse(atob(localStorage.getItem('vendor_facilityData')));
        //     }
        // }
        if (this.vendor['role'] === CONSTANT_VALUES.SUPER_ADMIN) {

            if (this.vendor.subVendors.length > 0) {
                let subVendor = this.vendor.subVendors[0];
                this.appService.getFacilityByClub(subVendor._id);
            }
        } else if (this.vendor['role'] === CONSTANT_VALUES.ROLE_STAFF) {
            this.appService.getFacilityByClub(this.vendor.vendorId);
        } else {
            this.appService.getFacilityByClub(this.vendor._id);
        }
        if (localStorage.getItem('vendor_facilityData')) {
            this.facilityData = JSON.parse(atob(localStorage.getItem('vendor_facilityData')));
        }
        this.getCategory(null);
        //this.setUnitName();

        this.height = (this.windowHeight - (this.topNav + this.midNav + this.container + this.footer + this.divHeight
            + this.listheight)) + 'px';
    }

    ngOnInit() {
        this.calenderLocale.en = {
            // dayNamesMin: ['S', 'M', 'T', 'W', 'T', 'F', 'S']
            firstDayOfWeek: 1,
            dayNames: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
            dayNamesShort: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
            dayNamesMin: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
            monthNames: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
            monthNamesShort: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
        };
        this.timezoneOffset = this.vendor.timezoneOffset * -1;
        let timeZoneDate = moment().utcOffset(this.timezoneOffset);
        let year = timeZoneDate.year(), month = timeZoneDate.month(), date = timeZoneDate.date(), hour = timeZoneDate.hour(), minutes = timeZoneDate.minutes();
        this.calendarDate = (new Date(year, month, date, hour, minutes));
        this.schedulerDate = (moment().utcOffset(this.timezoneOffset).format());
        this.emitOpenFrameEvent();
        this.header = {
            // left: 'prev,next today',
            // center: 'title',
            right: 'agendaDay,agendaWeek' // right: 'month,agendaWeek,agendaDay'
        };
        this.timezoneOffset = this.vendor.timezoneOffset * -1;
        this.events = [];
        this.scheduleLocale.en = {
            firstDay: 1
        }
        // Temporary static events for example and testing purpose

        // this.events = [
        //     {
        //         'title': 'All Day Event',
        //         'start': '2016-11-23'
        //     },
        //     {
        //         'title': 'Long Event',
        //         'start': '2016-11-28T12:00:00.000Z',
        //         'end': '2016-11-28T13:00:00.000Z',
        //         'allDay': false,
        //         'borderColor': 'red',
        //         'textColor': 'blue',
        //         'className': 'tb-full-width'
        //     },
        //     {
        //         'title': 'Repeating Event',
        //         'start': '2016-11-28T16:00:00',
        //         'end': '2016-11-28T17:00:00.000Z',
        //         'allDay': false
        //     },
        //     {
        //         'title': 'Repeating Event',
        //         'start': '2016-11-16T16:00:00'
        //     },
        //     {
        //         'title': 'Conference',
        //         'start': '16:00:00',
        //         'end': '17:00:00',
        //         'allDay': true,
        //         'className': 'closed'
        //     }
        // ];
        this.getFirstAndLastDateOfMonth();
    }

    ngOnDestroy() {
        jQuery('.ui-widget').fullCalendar('destroy');
    }

    isBookingAllowedForSportsCategory(selectedDate) {
        let currentDate = moment().utcOffset(this.vendor.timezoneOffset * -1, true);
        let lastBookingDate;

        if ((currentDate.day() === 5 && currentDate.hour() >= 18) || _.includes([6, 0], currentDate.day())) {
            lastBookingDate = moment().utcOffset(this.vendor.timezoneOffset * -1, true).day(0 + 7 + 7); // 0+7+7 means upto next Sunday
        } else {
            lastBookingDate = moment().utcOffset(this.vendor.timezoneOffset * -1, true).day(0 + 7); // 0+7 means upto coming Sunday
        }
        return selectedDate.isAfter(lastBookingDate.endOf("day")) ? false : true;
    }

    handleDayClick(e, msgPopUpObj, popUpObj, bookingPopUpObj, bookingUnavailablePopUpObj) {
        if (this.vendor.role.indexOf(CONSTANT_VALUES.SUPER_ADMIN) < 0) {
            this.currentEvent = e;
            e.date._i[4] = 0;
            let bookingDate = moment(e.date._i).utcOffset(this.vendor.timezoneOffset * -1, true);
            bookingDate.set({ 'second': 0, 'minute': 0, 'millisecond': 0 });
            let currentDate = moment().utcOffset(this.vendor.timezoneOffset * -1);
            // currentDate.set({ 'second': 0, 'minute': 0, 'millisecond': 0 });

            this.dialogVisible = true;
            this.popupTitle = this.facility.name;

            /* time zone offset calculation, new start and end based on timezoneOffset*/
            this.eventData.startTimeNew = moment(e.date._i).utcOffset(this.timezoneOffset, true);
            let mom = moment(e.date._i).utcOffset(this.timezoneOffset, true);
            this.eventData.endTimeNew = moment(e.date._i).utcOffset(this.timezoneOffset, true).add(parseInt(this.facility.slotDuration), 'h');


            // trigger detection manually as somehow only moving the mouse quickly after click triggers the automatic detection
            this.cd.detectChanges();
            this.startTimeOfFacility = (this.facility.timings.openTime + '').split(':')[0];
            this.endTimeOfFacility = (this.facility.timings.closeTime + '').split(':')[0];
            if (e.jsEvent.target.className.indexOf('closed') !== -1 || bookingDate.isBefore(currentDate)) {
                this.bookingPopupMessage = 'You cannot do booking for this slot';
                msgPopUpObj.showChildModal();
            } else if (this.checkForSports() && !this.isBookingAllowedForSportsCategory(moment(bookingDate).utcOffset(this.vendor.timezoneOffset * -1, true))) {
                bookingUnavailablePopUpObj.showChildModal();
            } else if (this.eventData.startTimeNew.hour() >= parseInt(this.startTimeOfFacility) &&
                (this.eventData.startTimeNew.hour() + parseInt(this.facility.slotDuration) <= parseInt(this.endTimeOfFacility))) {
                bookingPopUpObj.showChildModal(null, this.facility);
            } else {
            }
        } else {
            this.bookingPopupMessage = 'Sorry, Super Admin is not allowed to make booking';
            msgPopUpObj.showChildModal();
        }
    }

    handleEventClick(e, popUpObj, wailistPopUpObj) {
        this.eventData.start = e.calEvent.start._i;
        this.eventData.end = e.calEvent.end._i;
        this.eventData.startTimeNew = moment(e.calEvent.start._i).utcOffset(this.timezoneOffset, true);
        this.eventData.endTimeNew = moment(e.calEvent.end._i).utcOffset(this.timezoneOffset, true);

        // if (e.calEvent.className.indexOf('payment-booked') > -1) {
        //     this.event = new MyEvent();
        //     this.currentEvent = e.calEvent;
        //     this.event.title = e.calEvent.title;
        //     popUpObj.showChildModal();
        // } else if (e.calEvent.className.indexOf('waitlist') > -1) {
        //     this.popupTitle = this.facility.name;
        //     wailistPopUpObj.showChildModal();
        // }
        this.popupTitle = this.facility.name;
        wailistPopUpObj.showChildModal();
    }

    saveEvent() {
        if (this.event.id) {
            //  update
            let index: number = this.findEventIndexById(this.event.id);
            if (index >= 0) {
                this.events[index] = this.event;
            }
        } else {
            // new
            this.event.id = this.idGen;
            this.events.push(this.event);
            this.event = null;
        }

        this.dialogVisible = false;
    }

    deleteEvent() {
        let index: number = this.findEventIndexById(this.event.id);
        if (index >= 0) {
            this.events.splice(index, 1);
        }
        this.dialogVisible = false;
    }
    // this is one for getting all events from this.currentBookingList
    findEventIndexById(id: number) {
        let index = -1;
        for (let i = 0; i < this.events.length; i++) {
            if (id === this.events[i].id) {
                index = i;
                break;
            }
        }

        return index;
    }

    dateChange(event) {
        this.schedulerDate = this.calendarDate;
        // if (this.calendarDate.getTime() < this.calendarStartDate.getTime() ||
        //     this.calendarDate.getTime() > this.calendarEndDate.getTime()) {
        //     if (this.currentFilterValue === 'All') {
        //         this.showUnitBookings(this.selectedUnit, this.facility['_id'], this.calendarDate, false);
        //     } else if (this.currentFilterValue === 'Confirmed') {
        //         this.showUnitBookings(this.selectedUnit, this.facility['_id'], this.calendarDate, true);
        //     }
        // } else {
        // }
        // if (this.calendarDate < this.bookingSlotStart || this.calendarDate > this.bookingSlotEnd) {
        //     this.unitClickHandler(this.selectedUnit, this.facility['_id'], this.calendarDate);
        // }
        jQuery('.ui-widget').fullCalendar('gotoDate', this.calendarDate);
    }

    monthChange(event) {
        let tempDate1, tempDate2, monthNumber;
        let reg = /jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec/i;
        try {
            let monthAndYear: string;
            let month: string;
            let year: string;
            if (event.srcElement.className.indexOf('left') > -1 || event.srcElement.className.indexOf('right') > -1) {
                monthAndYear = event.srcElement.parentElement.parentElement.children[2].innerText.trim();
            } else {
                monthAndYear = event.srcElement.parentElement.parentElement.children[0].innerText.trim();
            }
            if (reg.test(monthAndYear)) {
                month = monthAndYear.split(' ')[0].trim();
                year = monthAndYear.split(' ')[1].trim();
                console.log('month', month);
                // tempDate1 = Date.parse(month + "1, 2017");
                monthNumber = parseInt(moment().utcOffset(480).month(month).format("M")) - 1;
                console.log('monthNumber', monthNumber);

                // let tempDate = moment().utcOffset(this.timezoneOffset, true);
                //  this.firstDay = moment([tempDate.year(), tempDate.month() - 1]).utcOffset(this.timezoneOffset, true);
                // this.lastDay = moment(this.firstDay).utcOffset(this.timezoneOffset, true).endOf('month');


                // tempDate2 = new Date();
                // this.firstDay = new Date(tempDate2.getFullYear(), month, 1);
                let tempDate = moment().utcOffset(this.timezoneOffset, true);
                this.firstDay = moment([tempDate.year(), parseInt(monthNumber) - 1]).utcOffset(this.timezoneOffset, true);

                this.lastDay = moment(this.firstDay).utcOffset(this.timezoneOffset, true).endOf('month');
                if (this.firstDay < this.bookingSlotStart || this.lastDay > this.bookingSlotEnd) {
                    this.unitClickHandler(this.selectedUnit, this.facility['_id'], this.calendarDate);
                }
            }
        } catch (err) {
            console.log(err);
        }
    }

    /**
       * while menu slide left to right as well as we shift header, footer and body too by broadcaster
       */
    registerTypeBroadcast() {
        this.messageEvent.on()
            .subscribe(bool => {
                this.shouldSlide = bool;
            });

        this.sidemenuToCalendarEvent.on()
            .subscribe(message => {
                this.paymentfilter = this.currentFilterValue;
                this.getCategory(message);
            });
    }

    /**
       * function show menu at add member page by broadcaster
       */

    emitTypeBroadcast() {
        let isShow = {
            privacypolicy: true,
            support: false,
            footer: 'block'
        };
        this.signInEvent.fire('block');
        this.hiddenFooter.fire(isShow);
    }

    emitOpenFrameEvent() {
        this.openFrameEvent.fire(false);
    }

    /**
       * Temproray function
       */
    homeScreen() {
        this.utilityFunctions.homeScreen(this)
    }

    showFacility(facilityId) {
        if (facilityId) {
            let facilityObj = {};
            facilityObj = this.facility_list.filter(function (rec) {
                if (rec._id === facilityId) {
                    return rec;
                }
            });
            this.facility = facilityObj[0];
            this.setPeakTim();
            // Don't remove this code because it will be use in future for business timing
            //    let businessHours = [ // specify an array instead
            //         {
            //             dow: [ 1, 2, 3 ], // Monday, Tuesday, Wednesday
            //             start: this.getGMTHoursFormat(this.facility.timings.openTime), // 8am
            //              end: this.getGMTHoursFormat(this.facility.timings.closeTime) // 6pm
            //          },
            //         {
            //             dow: [ 4, 5 ], // Thursday, Friday
            //             start: '10:00', // 10am
            //             end: '16:00' // 4pm
            //         }
            //     ];
            // jQuery('.ui-widget').fullCalendar('option', {
            //                 minTime: (this.facility.timings.openTime.substring(0, this.facility.timings.openTime.length - 6)),
            //                 maxTime: (this.facility.timings.closeTime.substring(0, this.facility.timings.closeTime.length - 6)),
            //             });
            // jQuery('.ui-widget').fullCalendar('option', 'aspectRatio', 1.6);
            this.facilityRule.peekTimings = [];
            this.facilityRule.breakTimings = [];
            this.modifyTimeToShow();
            //  jQuery('.ui-widget').fullCalendar('option', 'businessHours', businessHours);
            this.unitClickHandler(this.facility.unitNames[0], this.facility['_id'], this.calendarDate);
        }
        // this.loaderEvent.fire(true);
    }

    unitClickHandler(unit, facilityId, date) {
        if (this.currentFilterValue === 'All') {
            this.showUnitBookings(unit, facilityId, date, false);
        } else if (this.currentFilterValue === 'Confirmed') {
            this.showUnitBookings(unit, facilityId, date, true);
        }
    }

    showUnitBookings(unitName, facilityId, filterDate, skipWaitlist) {
        let startDate, endDate;
        let unitBooking = [];
        ///if (!this.delegate) {
        this.loaderEvent.fire(false);
        // this.delegate = true;
        if (unitName && facilityId) {
            this.events = [];
            let that = this;
            this.selectedUnit = unitName;
            if (!filterDate) { filterDate = new Date(); }
            //  let date = new Date(filterDate.getTime());
            // let filter1 = new Date(filterDate.getTime());
            // let filter2 = new Date(filterDate.getTime());
            // let filter1 = new Date();
            // let filter2 = new Date();
            let filter1 = moment().utcOffset(this.timezoneOffset, true);
            let filter2 = moment().utcOffset(this.timezoneOffset, true);
            if (this.firstDay < this.bookingSlotStart) {
                startDate = this.firstDay;
                endDate = this.bookingSlotStart;
                this.bookingSlotStart = startDate;
            } else if (this.lastDay > this.bookingSlotEnd) {
                startDate = this.bookingSlotEnd;
                endDate = this.lastDay;
                this.bookingSlotEnd = endDate;
            } else {
                // startDate = new Date(filter1.setDate(this.firstDay.getDate() - 90));
                // endDate = new Date(filter2.setDate(this.lastDay.getDate() + 90));
                startDate = this.firstDay.utcOffset(this.timezoneOffset, true).subtract(90, 'd');
                endDate = this.lastDay.utcOffset(this.timezoneOffset, true).add(90, 'd')
                this.bookingSlotStart = startDate;
                this.bookingSlotEnd = endDate;
            }
            // if (this.firstDay < this.bookingSlotStart || this.lastDay > this.bookingSlotEnd) {
            //     startDate = this.firstDay;
            //     endDate = this.lastDay;
            // } else {
            //     startDate = new Date(filter1.setDate(filter1.getDate() - 120));
            //     // this.calendarStartDate = new Date(startDate);
            //     endDate = new Date(filter2.setDate(filter2.getDate() + 120));
            // }

            // this.calendarEndDate = new Date(endDate);
            let reqObject = {
                'facilityId': facilityId,
                'startDate': moment(startDate).utcOffset(that.timezoneOffset, true),
                'endDate': moment(endDate).utcOffset(that.timezoneOffset, true),
                'vendorId': ''
            };
            that.bookingData = [];
            let waitList = [];
            let bookedList = [];
            let unitList = [];
            this.facility.breakTimings.map(function (rec) {
                let breakObj = {
                    'title': '',
                    'start': (rec.start.substring(0, rec.start.length - 6)),
                    'end': (rec.end.substring(0, rec.end.length - 6)),
                    'allDay': true,
                    'className': 'closed',
                    'rendering': 'background'
                };
                that.bookingData.push(breakObj);
            });
            if (this.vendor['role'] === CONSTANT_VALUES.SUPER_ADMIN) {
                if (this.vendor.subVendors.length > 0) {
                    let subVendor = this.vendor.subVendors[0];
                    reqObject.vendorId = subVendor._id;
                }
            } else if (this.vendor['role'] === CONSTANT_VALUES.ROLE_STAFF) {
                reqObject.vendorId = this.vendor.vendorId;
            } else {
                reqObject.vendorId = this.vendor._id;
            }
            this.facility.peekTimings.map(function (rec) {
                let peakTimeObj = {
                    'title': '',
                    'start': (rec.start.substring(0, rec.start.length - 6)),
                    'end': (rec.end.substring(0, rec.end.length - 6)),
                    'allDay': true,
                    'className': 'peaktime',
                    'rendering': 'background'
                };
                that.bookingData.push(peakTimeObj);
            });
            //this.currentBookingList = [];

            this.calendarService.getBookingsByFacility(reqObject).then((result: any) => {
                let calendarWidget = jQuery('.ui-widget');
                // this.calendarData = result.bookingData;
                if (result.status === 'SUCCESS') {
                    //this.currentBookingList = this.currentBookingList.concat(_.sortBy(result.bookingData, [function (rec) { return rec['waitlistCount']; }]));
                    // this.currentBookingList = _.merge(this.currentBookingList, result.bookingData);
                    this.currentBookingList = result.bookingData;
                    this.currentBookingList = _.uniqWith(this.currentBookingList, _.isEqual);
                    // list of booking and waitlistcount greter than 0
                    unitList = this.currentBookingList.filter(function (rec) {
                        return (rec['unitName'] === unitName);
                    });

                    bookedList = this.currentBookingList.filter(function (rec) {
                        return (rec['unitName'] === unitName);
                    });
                    // if (!skipWaitlist) {
                    //     waitList = this.currentBookingList.filter(function (rec) {
                    //         if (rec['waitlistCount'] > 0) {
                    //             unitList.push(rec);
                    //             return true;
                    //         } else {
                    //             return false;
                    //         }

                    //     });
                    // }
                    let filteredArray = unitList;
                    let dateStartIso;
                    let dateEndIso;
                    filteredArray.map(function (rec) {
                        if (that.currentFilterValue == 'Confirmed' && rec['bookingStatus'] == 'waitlist') {
                            return;
                        } else {
                            let status = (rec['bookingStatus'] == 'waitlist' ? 'waitlist' : 'booked');
                            if (rec['isPaymentDone'] !== undefined && !rec['isPaymentDone']) {
                                status = (rec['bookingStatus'] == 'waitlist' ? 'waitlist' : 'payment-booked');
                            }
                            let bookObj = {
                                start: moment(rec.startTime).utcOffset(that.timezoneOffset).format(),
                                end: moment(rec.endTime).utcOffset(that.timezoneOffset).format(),
                                title: (status !== 'waitlist' ? rec.membershipId : ''),
                                bookingId: rec.bookingId,
                                facilityId: rec.facilityId,
                                className: status,
                                status: status,
                                bookingStatus: rec['bookingStatus'],
                                waitlistCount: rec['waitlistCount'],
                                userId: rec['userId'],
                                unitName: rec.unitName,
                                fullName: rec.fullName,
                                attendees: rec.attendees,
                                isPaymentDone: rec.isPaymentDone
                                // rendering: 'background'
                            };
                            that.bookingData.push(bookObj);
                        }
                    });
                    calendarWidget.fullCalendar('option', {
                        minTime: (this.facility.timings.openTime.substring(0, this.facility.timings.openTime.length - 6)),
                        maxTime: (this.facility.timings.closeTime.substring(0, this.facility.timings.closeTime.length - 6))
                        // aspectRatio: 1.6
                    });
                    calendarWidget.fullCalendar('option', 'height', 520);
                    calendarWidget.fullCalendar('option', 'scrollTime', (this.facility.timings.openTime.substring(0, this.facility.timings.openTime.length - 3)));
                    this.bookingData = _.uniqWith(this.bookingData, _.isEqual);

                    that.events = this.bookingData;
                    // this.bookingData = this.bookingData.filter(function (rec: any) {
                    //     if (rec.unitName == that.selectedUnit) {
                    //         that.events.push(rec);
                    //     }
                    //     return rec;
                    // });
                    that.loaderEvent.fire(true);
                }

            });
        }
    }

    convertIntoUTCDate(date) {
        let now = new Date();
        switch (typeof date) {
            case 'string': now = new Date(date);
                break;
            case 'number': now = new Date(date);
                break;
            default: now = date;
        }

        let now_utc = new Date(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate(), now.getUTCHours(),
            now.getUTCMinutes(), now.getUTCSeconds());
        return now_utc;

    }

    getCategory(category) {
        this.loaderEvent.fire(false);
        // jQuery('.ui-widget').fullCalendar('axisFormat', 'H:mm');
        if (!category) {
            this.category = JSON.parse(this.appService.getCategoryForCalendar());
        } else {
            this.category = category;
        }
        let categoryName = '';
        if (this.category) {
            categoryName = this.category['categoryName'];
            localStorage.removeItem('category');
        }
        this.category = {};
        let vendorObj: any = {};
        if (this.vendor['role'] === CONSTANT_VALUES.SUPER_ADMIN) {
            if (this.vendor.subVendors.length > 0) {
                let subVendor = this.vendor.subVendors[0];
                vendorObj.vendorId = subVendor._id;
            }
        } else if (this.vendor['role'] === CONSTANT_VALUES.ROLE_STAFF) {
            vendorObj.vendorId = this.vendor.vendorId;
        } else {
            vendorObj.vendorId = this.vendor._id;
        }
        this.appService.getClubFacility(vendorObj).then((result: any) => {
            if (result.status === 'SUCCESS' && result.facilityData.length > 0) {
                this.showFacilities = true;
                if (categoryName) {
                    this.category = _.find(result.facilityData, function (rec) { return (rec['categoryName'] === categoryName); });
                } else {
                    this.category = result.facilityData[0];
                }
                if (this.category) {
                    this.facility_list = this.category['data'];
                    this.showFacility(this.facility_list[0]._id);
                } else {
                    this.showFacilities = false;
                }
                let obj = {
                    category: this.category['categoryName'],
                    menu: 'Calendar'
                };
                this.sidemenuSubCategory.fire(obj);
            } else {
                this.message = CONSTANT_MESSAGES.MESSAGE_NO_ACTIVITY_ADDED;
                this.loaderEvent.fire(true);
            }
        });
    }

    // Payment by onclick event

    show(bool: boolean, popUpObj) {
        this.loaderEvent.fire(false);
        if (bool && this.currentEvent && !this.currentEvent.waitlistCount && this.currentEvent.className[0] === 'payment-booked') {
            let that = this;
            let paymentObj = {
                'bookingId': this.currentEvent.bookingId,
                '_id': this.currentEvent.userId,
                'vendorId': this.vendor._id
            };
            this.calendarService.makePayment(paymentObj).then((result: any) => {
                if (result.status === 'SUCCESS') {
                    this.unitClickHandler(that.selectedUnit, that.facility['_id'], that.calendarDate);
                } else {
                }
            });
        } else {
        }
        this.loaderEvent.fire(true);
    }

    getGMTHoursFormat(str) {
        let utcHr: string;
        let currDate = new Date();
        let timeArr = [];
        timeArr = str.split(':');
        currDate.setUTCHours(parseInt(timeArr[0]), parseInt(timeArr[1]));
        let hr = currDate.getHours();
        if (hr < 10) {
            utcHr = '0' + hr + ':00:00';
            return utcHr;
        } else {
            return hr.toString() + ':00:00';
        }
    }

    getUtcFormat(str) {
        let utcHr: string;
        let timeArr = [];
        timeArr = str.split(':');
        let currDate = new Date();
        currDate.setHours(parseInt(timeArr[0]), parseInt(timeArr[1]), 0, 0);
        let hr = currDate.getUTCHours();
        let min = currDate.getUTCMinutes();
        if (hr < 10) {
            utcHr = '0' + hr + ':' + min;
            return utcHr;
        } else {
            return hr.toString() + ':' + min;
        }
    }

    settUtcFormat(str) {
        let utcHr: string;
        let currDate = new Date();
        let timeArr = [];
        timeArr = str.split(':');
        currDate.setUTCHours(parseInt(timeArr[0]), parseInt(timeArr[1]));
        let hr = currDate.getHours();
        if (hr < 10) {
            utcHr = '0' + hr;
            return utcHr;
        } else {
            return hr.toString();
        }
    }

    modifyTimeToShow() {
        let timeObject = {};
        this.facilityRule.timings.openTime = this.facility.timings.openTime.replace(/:00:00/g, '');
        this.facilityRule.timings.closeTime = this.facility.timings.closeTime.replace(/:00:00/g, '');
        for (let i = 0; i < this.facility.breakTimings.length; i++) {

            timeObject['start'] = this.facility.breakTimings[i].start.replace(/:00:00/g, '');
            timeObject['end'] = this.facility.breakTimings[i].end.replace(/:00:00/g, '');
            this.facilityRule.breakTimings.push(timeObject);
            timeObject = {};
        }
        for (let item of this.facility.peekTimings) {
            timeObject['start'] = item.start.replace(/:00:00/g, '');
            timeObject['end'] = item.end.replace(/:00:00/g, '');
            this.facilityRule.peekTimings.push(timeObject);
            timeObject = {};
        }
    }

    applyFilter() {
        this.events = [];
        this.filterSate = this.paymentfilter;
        if (this.paymentfilter === 'All') {
            this.currentFilterValue = 'All';
            this.unitClickHandler(this.selectedUnit, this.facility['_id'], this.calendarDate);
        } else if (this.paymentfilter === 'Confirmed' && this.currentBookingList) {
            this.loaderEvent.fire(false);
            this.currentFilterValue = 'Confirmed';
            let bookingData = [];
            let that = this;
            this.calendarData = JSON.parse(JSON.stringify(this.currentBookingList));
            this.facility.breakTimings.map(function (rec) {
                let breakObj = {
                    'title': '',
                    'start': (rec.start.substring(0, rec.start.length - 6)),
                    'end': (rec.end.substring(0, rec.end.length - 6)),
                    'allDay': true,
                    'className': 'closed',
                    'rendering': 'background'
                };
                bookingData.push(breakObj);
            });
            this.facility.peekTimings.map(function (rec) {
                let peakTimeObj = {
                    'title': '',
                    'start': (rec.start.substring(0, rec.start.length - 6)),
                    'end': (rec.end.substring(0, rec.end.length - 6)),
                    'allDay': true,
                    'className': 'peaktime',
                    'rendering': 'background'
                };
                bookingData.push(peakTimeObj);
            });
            this.calendarData.map(function (rec) {
                if (!rec.waitlistCount && that.selectedUnit === rec['unitName']) {
                    let status;
                    if (rec['isPaymentDone'] !== undefined) {
                        status = (rec['isPaymentDone'] ? 'booked' : 'payment-booked');
                    } else {
                        status = 'booked';
                    }
                    let bookObj = {
                        start: moment(rec.startTime).utcOffset(that.timezoneOffset).format(),
                        end: moment(rec.endTime).utcOffset(that.timezoneOffset).format(),
                        title: (status !== 'waitlist' ? rec.membershipId : ''),
                        bookingId: rec.bookingId,
                        facilityId: rec.facilityId,
                        className: status,
                        status: status,
                        bookingStatus: rec['bookingStatus'],
                        waitlistCount: rec['waitlistCount'],
                        userId: rec['userId'],
                        unitName: rec.unitName,
                        fullName: rec.fullName,
                        attendees: rec.attendees,
                        isPaymentDone: rec.isPaymentDone
                        // rendering: 'background'
                    };
                    bookingData.push(bookObj);
                }
            });
            this.events = bookingData;
            this.loaderEvent.fire(true);
        }
    }

    bookingForMember(reqObject, popUpObj) {
        if (this.appService.getVendorRole() === CONSTANT_VALUES.ROLE_VENDOR_ADMIN) {
            reqObject['vendorId'] = this.vendor._id;
        } else {
            reqObject['vendorId'] = this.vendor.vendorId;
        }
        // reqObject['vendorId'] = this.vendor._id;
        reqObject['facilityId'] = this.facility['_id'];
        reqObject['isWalkInBooking'] = true;
        reqObject['title'] = this.facility['name'];
        reqObject['unitName'] = this.selectedUnit;
        this.calendarService.bookingForMember(reqObject).then((result: any) => {
            if (result.status === 'SUCCESS') {
            }
            this.bookingPopupMessage = result.message;
            popUpObj.showChildModal();
        });
    }

    refreshPage() {
        this.unitClickHandler(this.selectedUnit, this.facility['_id'], this.calendarDate);
    }

    maintainFilterState() {
        this.paymentfilter = this.filterSate;
        if (this.filterSate === 'All') {
            this.selectAll = true;
            this.selectConfirmed = false;
        } else {
            this.selectAll = false;
            this.selectConfirmed = true;
        }
    }

    timeConvert24to12(time) {
        let t = parseInt(time);
        if (isNaN(t)) return '00';
        if (t === 0) return '12 AM';
        else if (t === 12) return '12 PM';
        else if (t === 24) return '12 AM';
        else {
            let suffix = t > 12 ? ' PM' : ' AM';
            return t % 12 + suffix;
        }
    }

    setPeakTim() {
        this.peakTimeList = [];
        let that = this;
        if (this.facility.peekTimings instanceof Array) {
            this.facility.peekTimings.forEach((r) => {
                this.peakTimeList.push({
                    start: that.timeConvert24to12(r.start.split(':')[0]),
                    end: that.timeConvert24to12(r.end.split(':')[0])
                });
            });
        }
        // this.facility.peekTimings
        // this.peakTimeList = JSON.parse(JSON.stringify(this.facility.peekTimings));
        // for (let rec of this.peakTimeList) {
        //     rec.start = rec['start'].replace(':00:00:00', '');
        //     rec.end = rec['end'].replace(':00:00:00', '');
        // }
    }

    getFirstAndLastDateOfMonth() {
        // let tempDate = new Date();
        // this.firstDay = new Date(tempDate.getFullYear(), tempDate.getMonth(), 1);
        // this.lastDay = new Date(tempDate.getFullYear(), tempDate.getMonth() + 1, 0);
        // this.bookingSlotStart = this.firstDay;
        // this.bookingSlotEnd = this.lastDay;
        let tempDate = moment().utcOffset(this.timezoneOffset, true);
        this.firstDay = moment([tempDate.year(), tempDate.month() - 1]).utcOffset(this.timezoneOffset, true);
        this.lastDay = moment(this.firstDay).utcOffset(this.timezoneOffset, true).endOf('month');
    }

    deleteBooking(bookingObj) {
        _.remove(this.bookingData, function (n) {
            return n.bookingId === bookingObj.bookingId;
        });
        _.remove(this.currentBookingList, function (n) {
            return n.bookingId === bookingObj.bookingId;
        });
        this.unitClickHandler(this.selectedUnit, this.facility['_id'], this.calendarDate);
    }

    // setActivityTime() {
    //     this.facility.timings.openTime.substring(0, this.facility.timings.openTime.length - 6)
    //     this.activity.startTime = moment().utcOffset(this.timezoneOffset, true);
    //     this.activity.startTime.set('hour', parseInt(this.facility.timings.openTime));
    //     this.facility.timings.closeTime.substring(0, this.facility.timings.closeTime.length - 6);
    //     this.activity.endTime = moment().utcOffset(this.timezoneOffset, true);
    //     this.activity.endTime.set('hour', parseInt(this.facility.timings.closeTime));
    // }

    checkForSports() {
        if (_.indexOf(CONSTANT_VALUES.SPORTS, this.facility.category) >= 0) {
            return true;
        } else {
            return false;
        }
    }
}

export class MyEvent {
    id: number;
    title: string;
    start: string;
    end: string;
    allDay: boolean = true;
}



// WEBPACK FOOTER //
// ./src/app/primecalendar/prime-calendar/prime-calendar.component.ts